import ActionTypes from '../../../constants/ActionTypes';
import common from '../../_common/actions';
import Select from '../../Select'; // ============ creators ===========

var setActiveKey = common.setActiveKey(ActionTypes.AREAS.AREA_TREES);
var useIndexed = common.useIndexed(Select.areas.areaTrees.getSubstate, 'areaTrees', ActionTypes.AREAS.AREA_TREES);
var useKeys = common.useKeys(Select.areas.areaTrees.getSubstate, 'areaTrees', ActionTypes.AREAS.AREA_TREES);
var refreshUses = common.refreshUses(Select.areas.areaTrees.getSubstate, "areaTrees", ActionTypes.AREAS.AREA_TREES); // ============ actions ===========

function actionClearUseIndexed(componentId) {
  return {
    type: ActionTypes.AREAS.AREA_TREES.USE.INDEXED.CLEAR,
    componentId: componentId
  };
} // ============ export ===========


export default {
  refreshUses: refreshUses,
  setActiveKey: setActiveKey,
  useIndexed: useIndexed,
  useIndexedClear: actionClearUseIndexed,
  useKeys: useKeys,
  useKeysClear: common.useKeysClear(ActionTypes.AREAS.AREA_TREES)
};